import { cn } from "@/lib/utils";

/** Default UI body copy at sm size. */
export const TEXT_BODY = "text-sm font-normal text-foreground";

/** Secondary / helper / dialog description copy. */
export const TEXT_DESCRIPTION = "text-sm font-normal text-muted-foreground";

/** Page header subtitle beside the title. */
export const TEXT_PAGE_HEADER_DESCRIPTION =
  "text-xs font-normal text-muted-foreground";

/** Message author name in the chat timeline (above 14px body). */
export const TEXT_MESSAGE_AUTHOR =
  "text-[15px] font-medium text-message-author-fg";

/** Collapsible sidebar section label (Channels, DMs, Workspaces). */
export const TEXT_SECTION_LABEL_SIDEBAR =
  "text-[9px] font-semibold text-muted-foreground uppercase tracking-wide";

/** Page / panel section heading (Built-in Tools, Your Agents). */
export const TEXT_SECTION_LABEL =
  "text-xs font-medium text-muted-foreground uppercase tracking-wider";

/** Compact section label inside menus and admin lists. */
export const TEXT_SECTION_LABEL_MENU =
  "text-[10px] font-medium text-muted-foreground uppercase tracking-wider";

/** cmdk group headings — menu label + list padding. */
export const CMDK_GROUP_HEADING_CLASSES = `[&_[cmdk-group-heading]]:px-3 [&_[cmdk-group-heading]]:py-2 ${TEXT_SECTION_LABEL_MENU.split(
  " ",
)
  .map((c) => `[&_[cmdk-group-heading]]:${c}`)
  .join(" ")}`;

/** Form label (above the input). */
export const FORM_LABEL = cn("block", TEXT_BODY);

/** Form hint / helper text. */
export const FORM_HINT = TEXT_DESCRIPTION;
